export const SUCCESS_RESEND = 'A new link was sent to your email';